<template>
  <div class="usps">
    <h2 class="usps__title">{{ $t('homepage.usps.title') }}</h2>
    <div class="usps__grid container">
      <div v-for="item in 3" :key="item">
        <div class="usps__card">
          <h3 class="usps__card__title">{{ $t(`homepage.usps.options.${item}.title`) }}</h3>
          <p class="usps__card__description">{{ $t(`homepage.usps.options.${item}.description`) }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts"></script>

<style lang="scss" scoped>
@use '@/assets/styles/css_BASE/helpers/mixins/font-size.scss' as *;
@use '@/assets/styles/css_BASE/helpers/mixins/_bp.scss' as *;

.usps {
  background-color: var(--color-indigo-100);
  text-align: center;
  margin-top: 30px;
  padding: 25px 0px;
  width: 100%;
  @include bp(sm) {
    height: 300px;
    background: url('/assets/artnight/bgs/warum-AN-BG-tablet.png');
    background-size: contain;
  }
  @include bp(md) {
    background: url('/assets/artnight/bgs/warum-AN-BG-desktop.png') no-repeat center;
    background-size: cover;
    margin: 40px auto;
  }
  @include bp(lg) {
    margin-bottom: 60px;
  }

  &__title {
    color: var(--color-indigo-800);
    font-weight: 500;
    @include font-size(30px);
    letter-spacing: 0.48px;
    margin-bottom: 20px;
    line-height: 30px;
    @include bp(sm) {
      font-weight: 700;
      letter-spacing: -2%;
      @include font-size(36px);
      line-height: 130%;
    }
    @include bp(md) {
      font-weight: 700;
      letter-spacing: -2%;
      @include font-size(48px);
      line-height: 130%;
    }
  }

  &__grid {
    padding: 0px 40px;
    @include bp(sm-up) {
      padding: 0px 20px;
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      margin: auto;
      gap: 30px;
    }
  }

  &__card {
    margin: auto;
    background: white;
    border-radius: 16px;
    padding: 10px 15px;
    margin-bottom: 15px;
    box-shadow: 0px 8px 8px rgba(0, 0, 0, 0.2);
    height: 100%;

    &__title {
      @include font-size(20px);
      font-weight: 500;
      letter-spacing: 2%;
      margin-bottom: 5px;
    }

    &__description {
      @include font-size(14px);
      font-weight: 400;
      letter-spacing: 0.48px;
      color: var(--color-gray-700);
    }
  }
}
</style>
